export default [
    ['#4D2C1B', '#4D181B'],
    ['#004B15', '#00254D'],
    ['#464C3C', '#4C1217'],
    ['#2F004D', '#4D004B'],
    ['#333333', '#666666'],
];
